import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { BreadCrumbActions } from "../../store/breadcrumb-slice";
import Highcharts from "highcharts";
import PageHeader from "../../UI/PageHeader";
import TypeBasedFilter from "../../UI/TypeBasedFilter";
import { URL_CONFIG } from "../../constants/rest-config";
import { TYPE_BASED_FILTER_WITH_BETWEEN_DATES } from "../../constants/ui-config";
import { httpHandler } from "../../http/http-interceptor";
import DashboardCharts from "../Charts/DashboardCharts";
import { useTranslation } from "react-i18next";
import Isloading from "../../UI/CustomComponents/Isloading";
import { pageLoaderHandler } from "../../helpers";

const RewardsRecognition = (props) => {
  // const dispatch = useDispatch();
  const { t } = useTranslation();

  const { allUserDatas } = props;

  const [filterParams, setFilterParams] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  });
  const [rrData, setRRData] = useState({});
  const initAllUserDatas = allUserDatas ? allUserDatas : [];
  const [loginChart, setLoginChart] = useState({});
  const [recognitionChart, setRecognitionChart] = useState({});
  const [ecardChart, setEcardChart] = useState({});
  const [certificateChart, setCertificateChart] = useState({});
  const [badgeChart, setBadgeChart] = useState({});
  const [awardChart, setAwardChart] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const defaultChartOptions = {
    login: {
      chart: {
        type: "radialBar",
        height: "80%",
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          dataLabels: {
            name: {
              show: true,
              fontSize: "16px",
              color: "#333333",
            },
            value: {
              show: true,
              fontSize: "22px",
              color: "#333333",
              formatter: function (val) {
                return "Active User :" + rrData.loginUserCount;
              },
            },
          },
          track: {
            background: "#f0f0f0",
            strokeWidth: "100%",
          },
          hollow: {
            margin: 0,
            size: "70%",
            background: "#fff",
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          shadeIntensity: 0.15,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 50, 65, 91],
        },
      },
      series: [0], // Replace with your dynamic value
      labels: ["Logged IN"],
    },
    loginOld: {
      chart: {
        type: "gauge",
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: "80%",
      },
      title: {
        text: "",
      },
      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ["50%", "75%"],
        size: "110%",
      },
      yAxis: {
        min: 0,
        max: 200,
        tickPixelInterval: 72,
        tickPosition: "inside",
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || "#FFFFFF",
        tickLength: 20,
        tickWidth: 2,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: "14px",
          },
        },
        plotBands: [],
      },
      series: [
        {
          name: "Logged IN",
          data: [80],
          tooltip: {
            valueSuffix: "",
          },
          dataLabels: {
            // format: '{y} Logged IN',
            format: "Logged IN",
            borderWidth: 0,
            color:
              (Highcharts.defaultOptions.title &&
                Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) ||
              "#333333",
            style: {
              fontSize: "16px",
            },
          },
          dial: {
            radius: "80%",
            backgroundColor: "gray",
            baseWidth: 12,
            baseLength: "0%",
            rearLength: "0%",
          },
          pivot: {
            backgroundColor: "gray",
            radius: 6,
          },
        },
      ],
    },
    recognition: {
      chart: {
        renderTo: "container",
        type: "column",
        options3d: {
          enabled: true,
          alpha: 15,
          beta: 15,
          depth: 50,
          viewDistance: 25,
        },
      },

      xAxis: {
        categories: ["E-Cards", "Certificates", "Badges", "Awards"],
      },
      yAxis: {
        title: {
          enabled: false,
        },
      },
      tooltip: {
        headerFormat: "<b>{point.key}</b><br>",
        pointFormat: "Recognition: {point.y}",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          depth: 25,
        },
      },
      series: [],
    },
    badge: {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0,
        },
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}</b>",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          depth: 35,
          dataLabels: {
            enabled: true,
            format: "{point.name}",
          },
        },
      },
      series: [
        {
          type: "pie",
          name: "Badge",
          data: [
            ["Explorer", 23],
            ["Leader", 18],
            {
              name: "Innovation",
              y: 12,
              sliced: true,
              selected: true,
            },
            ["Performer*", 9],
            ["Elite", 8],
            ["Team Changer", 30],
          ],
        },
      ],
    },
    badge1: {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
      },
      title: {
        text: "",
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "",
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: "Badge",
          colorByPoint: true,
          data: [
            {
              name: "Leader",
              y: 44,
              sliced: true,
              selected: true,
            },
            {
              name: "Explorer",
              y: 22,
            },
            {
              name: "Innovation",
              y: 4,
            },
            {
              name: "Performer",
              y: 12,
            },
            {
              name: "Elite",
              y: 2,
            },
            {
              name: "Team Changer",
              y: 9,
            },
          ],
        },
      ],
    },
    awards: {
      chart: {
        type: "column",
        zoom: {
          enabled: false,
        },
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        categories: [
          "All Star",
          "Dark Knight",
          "Legendary",
          "Leviosa",
          "Omega",
          "Performer",
          "Picasso",
          "Premier",
          "Rockstar Rockie",
          "Super Squad",
          "Team Infinity",
          "Transformer",
        ],
        crosshair: true,
      },
      yAxis: {
        title: {
          useHTML: true,
          text: "",
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [
        {
          name: "Spot Awards",
          data: [13, 9, 7, 13, 14, 5, 3, 8, 11, 4, 10, 12],
        },
        {
          name: "Nomination Awards",
          data: [12, 10, 11, 7, 11, 7, 9, 0, 1, 4, 2, 6],
        },
      ],
    },
    certificate: {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
      },
      title: {
        // text: 'Browser<br>shares<br>January<br>2022',
        text: "Certificates",
        align: "center",
        verticalAlign: "middle",
        y: 60,
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "",
        },
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -50,
            style: {
              fontWeight: "bold",
              color: "white",
            },
          },
          startAngle: -90,
          endAngle: 90,
          center: ["50%", "75%"],
          size: "110%",
        },
      },
      series: [
        {
          type: "pie",
          name: "Certificate",
          innerSize: "50%",
          data: [
            ["Kudos", 35],
            ["Excellence", 55],
            ["Achievement", 10],
          ],
        },
      ],
    },
    ecards: {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 45,
        },
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45,
        },
      },
      series: [],
    },
  };

  const apexChartOptions = {
    recognition: {
      labels: ["E-Cards", "Certificates", "Badges", "Awards"],
      chart: {
        height: 350,
        type: "bar",
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        width: 2,
      },

      grid: {
        row: {
          colors: ["#fff", "#f2f2f2"],
        },
      },
      xaxis: {
        categories: [
          t(`dashboard.E-Cards`),
          t(`dashboard.Certificates`),
          t(`dashboard.Badges`),
          t(`dashboard.Awards`),
        ],
        tickPlacement: "on",
      },
      yaxis: {
        title: {
          text: "",
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          columnWidth: "50%",
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ["#000"],
          boxShadow: "none",
        },
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.85,
          opacityTo: 0.85,
          stops: [50, 0, 100],
        },
      },
      series: [],
    },
    ecards: {
      labels: [],
      dataLabels: {
        enabled: true,
      },
      chart: {
        type: "donut",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      legend: {
        show: true,
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45,
          donut: {
            labels: {
              show: false,
            },
          },
        },
      },
      series: [],
    },
    old_certificate: {
      labels: [
        t(`dashboard.Kudos`),
        t(`dashboard.Excellence`),
        t(`dashboard.Achievement`),
      ],
      dataLabels: {
        enabled: true,
      },
      chart: {
        type: "donut",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      legend: {
        show: true,
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45,
          donut: {
            labels: {
              show: false,
            },
          },
        },
      },
      series: [],
    },
    certificate: {
      // labels: [
      //   t(`dashboard.Kudos`),
      //   t(`dashboard.Excellence`),
      //   t(`dashboard.Achievement`),
      // ],
      dataLabels: {
        enabled: false,
      },
      chart: {
        type: "bar",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      legend: {
        show: true,
      },
      xaxis: {
        categories: [
          "South Korea",
          "Canada",
          "United Kingdom",
          "Netherlands",
          "Italy",
          "France",
          "Japan",
          "United States",
          "China",
          "Germany",
        ],
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      series: [],
    },
    badge: {
      labels: [
        t(`dashboard.Explorer`),
        t(`dashboard.Leader`),
        t(`dashboard.Performer`),
        t(`dashboard.Elite`),
        t(`dashboard.Team Change`),
      ],
      dataLabels: {
        enabled: true,
      },

      chart: {
        type: "donut",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      legend: {
        show: true,
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45,
          donut: {
            labels: {
              show: false,
            },
          },
        },
      },
      series: [],
    },
    awards: {
      chart: {
        height: 350,
        type: "bar",
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        width: 2,
      },

      grid: {
        row: {
          colors: ["#fff", "#f2f2f2"],
        },
      },
      xaxis: {
        categories: [
          "All Star",
          "Dark Knight",
          "Legendary",
          "Leviosa",
          "Omega",
          "Performer",
          "Picasso",
          "Premier",
          "Rockstar Rockie",
          "Super Squad",
          "Team Infinity",
          "Transformer",
        ],
        tickPlacement: "on",
      },
      yaxis: {
        title: {
          text: "",
        },
      },

      plotOptions: {
        bar: {
          borderRadius: 0,
          columnWidth: "50%",
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ["#000"],
        },
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.85,
          opacityTo: 0.85,
          stops: [50, 0, 100],
        },
      },
      series: [
        {
          name: "Spot Awards",
          data: [13, 9, 7, 13, 14, 5, 3, 8, 11, 4, 10, 12],
        },
        {
          name: "Nomination Awards",
          data: [12, 10, 11, 7, 11, 7, 9, 0, 1, 4, 2, 6],
        },
      ],
    },
  };

  const breadcrumbArr = [
    {
      label: "Home",
      link: "app/dashboard",
    },
    {
      label: "Dashboard",
      link: "#",
    },
    {
      label: "Rewards & Recognition",
      link: "#",
    },
  ];

  const fetchRewardsRecognition = (paramsInfo) => {
    setIsLoading(true);
    let obj = {
      url: URL_CONFIG.REWARDS_RECOGNITION,
      method: "get",
    };
    if (Object.getOwnPropertyNames(paramsInfo)) {
      obj["params"] = paramsInfo;
    }
    httpHandler(obj)
      .then((response) => {
        setRRData(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("fetchRewardsRecognition error", error);
        setIsLoading(false);
      });
  };

  const getFilterParams = (paramsData) => {
    if (Object.getOwnPropertyNames(filterParams)) {
      setFilterParams({ ...paramsData });
    } else {
      setFilterParams({});
    }
    fetchRewardsRecognition(paramsData);
  };

  useEffect(() => {
    fetchRewardsRecognition(filterParams);
    pageLoaderHandler(isLoading ? "show" : "hide");
  }, []);

  useEffect(() => {
    if (rrData && Object.keys(rrData)?.length) {
      // Login Chart Start
      let loginChartTemp = defaultChartOptions.login;
      loginChartTemp["series"] = [
        (rrData.loginUserCount / initAllUserDatas.length) * 100,
      ];
      loginChartTemp["labels"] = ["Total User" + ":" + initAllUserDatas.length];
      rrData.loginUserCount > 0
        ? setLoginChart({ ...loginChartTemp })
        : setLoginChart({});
      // Login Chart End

      // Recognition Chart Start
      let recognitionChartTemp = apexChartOptions.recognition;
      recognitionChartTemp["series"] = [
        {
          name: "",
          data: [
            rrData.eCardsCount,
            rrData.certificateCount,
            rrData.badgeCount,
            rrData.awardCount,
          ],
          // colorByPoint: true
        },
      ];

      //setRecognitionChart({...recognitionChartTemp});
      rrData.eCardsCount > 0 ||
      rrData.certificateCount > 0 ||
      rrData.badgeCount > 0 ||
      rrData.awardCount > 0
        ? setRecognitionChart({ ...recognitionChartTemp })
        : setRecognitionChart({});
      // Recognition Chart End

      // E-Cards Chart Start
      let ecardsTemp = apexChartOptions.ecards;
      let data = [
        rrData?.birthdayECardsCount ? rrData?.birthdayECardsCount : 0,
        rrData?.anniversaryECardsCount ? rrData?.anniversaryECardsCount : 0,
        rrData?.appreciationECardsCount ? rrData?.appreciationECardsCount : 0,
        rrData?.seasonalECardsCount ? rrData?.seasonalECardsCount : 0,
      ];

      ecardsTemp["labels"] = [
        t(`dashboard.Birthday`),
        t(`dashboard.Anniversary`),
        t(`dashboard.Kudos`),
        t(`dashboard.Seasonal`),
      ];
      ecardsTemp["series"] = data;
      //   {
      //   name: 'E-Cards',
      //   data: [
      //       rrData?.birthdayECardsCount ? ['Birthday', rrData?.birthdayECardsCount] : [],
      //       rrData?.anniversaryECardsCount ? ['Anniversary', rrData?.anniversaryECardsCount] : [],
      //       rrData?.appreciationECardsCount ? ['Kudos', rrData?.appreciationECardsCount] : [],
      //       rrData?.seasonalECardsCount ? ['Seasonal', rrData?.seasonalECardsCount] : []
      //   ]
      // }
      //setEcardChart({...ecardsTemp});
      rrData.birthdayECardsCount > 0 ||
      rrData.anniversaryECardsCount > 0 ||
      rrData.appreciationECardsCount > 0 ||
      rrData.seasonalECardsCount > 0
        ? setEcardChart({ ...ecardsTemp })
        : setEcardChart({});
      // E-Cards Chart End

      // Certificate Chart Start
      let certificateTemp = apexChartOptions.certificate;
      const values =
        rrData.categorizedCertificateCount &&
        Object.keys(rrData.categorizedCertificateCount).length > 0
          ? Object.values(rrData.categorizedCertificateCount)
          : [];

      // certificateTemp["labels"] =
      //   Object.keys(rrData.categorizedCertificateCount).length > 0
      //     ? Object.keys(rrData?.categorizedCertificateCount)
      //     : [];
      //certificateTemp['series'] = values;
      certificateTemp.xaxis.categories =
        Object.keys(rrData.categorizedCertificateCount).length > 0
          ? Object.keys(rrData?.categorizedCertificateCount)
          : [];
      //certificateTemp.series.data = values;
      certificateTemp.series = [
        {
          data: values,
        },
      ];

      Object.keys(rrData.categorizedCertificateCount).length > 0
        ? setCertificateChart({ ...certificateTemp })
        : setCertificateChart({});
      // Certificate Chart End

      // Badge Chart Start
      let badgeTemp = apexChartOptions.badge;
      const badgeValue =
        rrData.categorizedBadgeCount &&
        Object.keys(rrData.categorizedBadgeCount).length > 0
          ? Object.values(rrData.categorizedBadgeCount)
          : [];
      badgeTemp["labels"] =
        Object.keys(rrData.categorizedBadgeCount).length > 0
          ? Object.keys(rrData?.categorizedBadgeCount)
          : [];
      badgeTemp["series"] = badgeValue;
      Object.keys(rrData.categorizedBadgeCount).length > 0
        ? setBadgeChart({ ...badgeTemp })
        : setBadgeChart({});
      // Badge Chart End

      // Award Chart Start
      let awardTemp = apexChartOptions.awards;
      let spotAwardArr = [];
      let nomiAwardArr = [];

      Object.keys(rrData["categorizedAwardCount"]).forEach(function (key) {
        if (key === "spot_award") {
          spotAwardArr.push(rrData["categorizedAwardCount"][key]); // push the correct value
        }
        if (key === "nomi_award") {
          nomiAwardArr.push(rrData["categorizedAwardCount"][key]); // push the correct value
        }
      });
      awardTemp["series"] = [
        {
          name: "Spot Awards",
          data: spotAwardArr,
        },
        {
          name: "Nomination Awards",
          data: nomiAwardArr,
        },
      ];
      Object.keys(rrData["categorizedAwardCount"]).length > 0
        ? setAwardChart({ ...awardTemp })
        : setAwardChart({});
      // Award Chart End
    }

    return () => {
      setLoginChart({});
      setRecognitionChart({});
      setEcardChart({});
      setCertificateChart({});
      setBadgeChart({});
      setAwardChart({});
    };
  }, [rrData]);

  return (
    <React.Fragment>
      <PageHeader
        title={t(`dashboard.Organization Stats`)}
        filter={
          <TypeBasedFilter
            config={TYPE_BASED_FILTER_WITH_BETWEEN_DATES}
            getFilterParams={getFilterParams}
          />
        }
      />
      <div className="py-4">
        {isLoading ? (
          <Isloading />
        ) : (
          <div className="row m-0" id="content-start">
            <div className="col-md-12">
              {/* <!-- Layer 1 START --> */}
              <div className="d_rewards_recog_div">
                <div className="col-xs-12 col-md-4 col-lg-3 col-xl-2 d_rewards_dtls">
                  <div className="card border-left-primary shadow h-100 py-0">
                    <div className="card-body p-3">
                      <div className="row no-gutters align-items-center">
                        <div className="col">
                          <div className="mb-2 text-capitalize">
                            {t(`dashboard.Users`)}( {t(`dashboard.Logged in`)})
                          </div>
                          <div className="d_recog_count">
                            <p className="mb-0 text-primary">
                              {rrData && rrData?.loginUserCount
                                ? rrData?.loginUserCount
                                : 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-4 col-lg-3 col-xl-2 d_rewards_dtls">
                  <div className="card eep-border-left-succ shadow h-100 py-0">
                    <div className="card-body p-3">
                      <div className="row no-gutters align-items-center">
                        <div className="col">
                          <div className="mb-2 text-capitalize">
                            {t(`dashboard.Recognition`)}
                          </div>
                          <div className="d_recog_count">
                            <p className="mb-0 eep-text-succ">
                              {rrData && rrData?.recognitionTotal
                                ? rrData?.recognitionTotal
                                : 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-4 col-lg-3 col-xl-2 d_rewards_dtls">
                  <div className="card eep-border-left-info shadow h-100 py-0">
                    <div className="card-body p-3">
                      <div className="row no-gutters align-items-center">
                        <div className="col">
                          <div className="mb-2 text-capitalize">
                            {t(`dashboard.E-Cards`)}
                          </div>
                          <div className="d_recog_count">
                            <p className="mb-0 eep-text-info">
                              {rrData && rrData?.eCardsCount
                                ? rrData?.eCardsCount
                                : 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-4 col-lg-3 col-xl-2 d_rewards_dtls">
                  <div className="card eep-border-left-warn shadow h-100 py-0">
                    <div className="card-body p-3">
                      <div className="row no-gutters align-items-center">
                        <div className="col">
                          <div className="mb-2 text-capitalize">
                            {t(`dashboard.Certificates`)}
                          </div>
                          <div className="d_recog_count">
                            <p className="mb-0 eep-text-warn">
                              {rrData && rrData?.certificateCount
                                ? rrData?.certificateCount
                                : 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-4 col-lg-3 col-xl-2 d_rewards_dtls">
                  <div className="card eep-border-left-light-grey shadow h-100 py-0">
                    <div className="card-body p-3">
                      <div className="row no-gutters align-items-center">
                        <div className="col">
                          <div className="mb-2 text-capitalize">
                            {t(`dashboard.Badges`)}
                          </div>
                          <div className="d_recog_count">
                            <p className="mb-0 eep-text-light-grey">
                              {rrData && rrData?.badgeCount
                                ? rrData?.badgeCount
                                : 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-4 col-lg-3 col-xl-2 d_rewards_dtls">
                  <div className="card eep-border-left-primary shadow h-100 py-0">
                    <div className="card-body p-3">
                      <div className="row no-gutters align-items-center">
                        <div className="col">
                          <div className="mb-2 text-capitalize">
                            {t(`dashboard.Awards`)}
                          </div>
                          <div className="d_recog_count">
                            <p className="mb-0 eep-text-primary">
                              {rrData && rrData?.awardCount
                                ? rrData?.awardCount
                                : 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Layer 1 END --> */}

              <div className="row">
                <div className="col-md-6 d_charts_div row_col_div">
                  <div className="bg-white shadow br-15 h-100">
                    <div className="p-3">
                      <label className="d_sect_lbl">
                        {t(`dashboard.Logged in`)}
                      </label>
                      {Object.keys(loginChart).length > 0 && (
                        <DashboardCharts
                          chartType="login"
                          chartData={loginChart}
                        />
                      )}
                      {Object.keys(loginChart).length <= 0 && (
                        <div
                          className="parent_div"
                          style={{ marginTop: "14vh", height: "200px" }}
                        >
                          <div className="eep_blank_div">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icons/static/noData.svg"
                              }
                              alt="no-data-icon"
                            />
                            <p className="eep_blank_quote">
                              {t(`dashboard.No records found`)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d_charts_div row_col_div">
                  <div className="bg-white shadow br-15 h-100">
                    <div className="p-3">
                      <label className="d_sect_lbl">
                        {t(`dashboard.Holistic Recognition`)}
                      </label>
                      {Object.keys(recognitionChart).length > 0 && (
                        <DashboardCharts
                          chartType="recognition"
                          chartData={recognitionChart}
                        />
                      )}
                      {Object.keys(recognitionChart).length <= 0 && (
                        <div
                          className="parent_div"
                          style={{ marginTop: "14vh", height: "200px" }}
                        >
                          <div className="eep_blank_div">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icons/static/noData.svg"
                              }
                              alt="no-data-icon"
                            />
                            <p className="eep_blank_quote">
                              {t(`dashboard.No records found`)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-6 d_charts_div row_col_div">
                <div className="bg-white shadow br-15 h-100">
                  <div className="p-3">
                    <label className="d_sect_lbl">
                      {t(`dashboard.Certificates`)}
                    </label>
                    {Object.keys(certificateChart).length > 0 && (
                      <DashboardCharts
                        chartType="certificate"
                        chartData={certificateChart}
                      />
                    )}
                    {Object.keys(certificateChart).length <= 0 && (
                      <div
                        className="parent_div"
                        style={{ marginTop: "14vh", height: "200px" }}
                      >
                        <div className="eep_blank_div">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/icons/static/noData.svg"
                            }
                            alt="no-data-icon"
                          />
                          <p className="eep_blank_quote">
                            {" "}
                            {t(`dashboard.No records found`)}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div> */}
                <div className="col-md-6 d_charts_div row_col_div">
                  <div className="bg-white shadow br-15 h-100">
                    <div className="p-3">
                      <label className="d_sect_lbl">
                        {" "}
                        {t(`dashboard.Badges`)}{" "}
                      </label>
                      {Object.keys(badgeChart).length > 0 && (
                        <DashboardCharts
                          chartType="badge"
                          chartData={badgeChart}
                        />
                      )}
                      {Object.keys(badgeChart).length <= 0 && (
                        <div
                          className="parent_div"
                          style={{ marginTop: "14vh", height: "200px" }}
                        >
                          <div className="eep_blank_div">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icons/static/noData.svg"
                              }
                              alt="no-data-icon"
                            />
                            <p className="eep_blank_quote">
                              {" "}
                              {t(`dashboard.No records found`)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d_charts_div row_col_div">
                  <div className="bg-white shadow br-15 h-100">
                    <div className="p-3">
                      <label className="d_sect_lbl">
                        {" "}
                        {t(`dashboard.Awards`)}
                      </label>
                      {Object.keys(awardChart).length > 0 && (
                        <DashboardCharts
                          chartType="awards"
                          chartData={awardChart}
                        />
                      )}
                      {Object.keys(awardChart).length <= 0 && (
                        <div
                          className="parent_div"
                          style={{ marginTop: "14vh", height: "200px" }}
                        >
                          <div className="eep_blank_div">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icons/static/noData.svg"
                              }
                              alt="no-data-icon"
                            />
                            <p className="eep_blank_quote">
                              {" "}
                              {t(`dashboard.No records found`)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 d_charts_div row_col_div">
                  <div className="bg-white shadow br-15 h-100">
                    <div className="p-3">
                      <label className="d_sect_lbl">
                        {t(`dashboard.Certificates`)}
                      </label>
                      {Object.keys(certificateChart).length > 0 && (
                        <DashboardCharts
                          chartType="certificate"
                          chartData={certificateChart}
                        />
                      )}
                      {Object.keys(certificateChart).length <= 0 && (
                        <div
                          className="parent_div"
                          style={{ marginTop: "14vh", height: "200px" }}
                        >
                          <div className="eep_blank_div">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icons/static/noData.svg"
                              }
                              alt="no-data-icon"
                            />
                            <p className="eep_blank_quote">
                              {" "}
                              {t(`dashboard.No records found`)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d_charts_div row_col_div">
                  <div className="bg-white shadow br-15 h-100">
                    <div className="p-3">
                      <label className="d_sect_lbl">
                        {t(`dashboard.E-Cards`)}
                      </label>
                      {Object.keys(ecardChart).length > 0 && (
                        <DashboardCharts
                          chartType="ecards"
                          chartData={ecardChart}
                        />
                      )}
                      {Object.keys(ecardChart).length <= 0 && (
                        <div
                          className="parent_div"
                          style={{ marginTop: "14vh", height: "200px" }}
                        >
                          <div className="eep_blank_div">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icons/static/noData.svg"
                              }
                              alt="no-data-icon"
                            />
                            <p className="eep_blank_quote">
                              {t(`dashboard.No records found`)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-6 d_charts_div row_col_div">
                <div className="bg-white shadow br-15 h-100">
                  <div className="p-3">
                    <label className="d_sect_lbl">Rewards</label>
                    {true && 
                      <DashboardCharts chartType="login"/>
                    }
                    {false &&
                      <div className="parent_div">
                        <div className="eep_blank_div">
                          <img src={process.env.PUBLIC_URL + "/images/icons/static/noData.svg"} alt="no-data-icon" />
                          <p className="eep_blank_quote">No records found</p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default RewardsRecognition;
